var _style, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 16,
    height: 16,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5A7197;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.2,10H28.1c-0.9,0-1.8,0.8-1.8,1.8v39.1c0,0.9,0.8,1.8,1.8,1.8l0,0c0.9,0,1.8-0.8,1.8-1.8V13.6h65.5v40.6 H48.3c-0.9,0-1.8,0.8-1.8,1.8l0,0c0,0.9,0.8,1.8,1.8,1.8h48.8c0.9,0,1.8-0.8,1.8-1.8V11.8C98.9,10.8,98.2,10,97.2,10z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.8,
    cy: 40.6,
    r: 9.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 83.2,
    cy: 69.9,
    r: 8.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51.4,
    cy: 69.9,
    r: 8.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.1,49.9L57.4,34c0.4-0.5,0.3-1.3-0.2-1.7c-0.5-0.4-1.3-0.3-1.7,0.2l-12.2,16c-1.2-0.4-2.5-0.2-3.5,0.6 l-8.2,7.1l-16.7-3.4c-0.2,0-0.5-0.1-0.7-0.1c-0.7-0.1-1.5-0.2-2.3-0.2h-0.2c-5.5,0-10,3.8-10,8.5v27.1h20.1V61.6l10,2 c0.2,0,0.4,0.1,0.7,0.1c0.8,0,1.7-0.3,2.3-0.8l9.5-8.2C45.8,53.4,46.1,51.4,45.1,49.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.3,80.2h-0.2c-6,0-10.7,3.4-10.7,7.6v0.4h21.8v-0.4C94.1,83.6,89.3,80.2,83.3,80.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,80.2h-0.2c-6,0-10.7,3.4-10.7,7.6v0.4h21.8v-0.4C62.2,83.6,57.4,80.2,51.5,80.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,19.4H43.6c-0.9,0-1.8,0.8-1.8,1.8c0,0.9,0.8,1.8,1.8,1.8h43.2c0.9,0,1.8-0.8,1.8-1.8S87.8,19.4,86.7,19.4 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,32.1H64.8c-0.9,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h22c0.9,0,1.8-0.8,1.8-1.8 C88.5,32.8,87.8,32.1,86.7,32.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,45.6H59.7c-0.9,0-1.8,0.8-1.8,1.8c0,0.9,0.8,1.8,1.8,1.8h27.2c0.9,0,1.8-0.8,1.8-1.8 C88.5,46.3,87.8,45.6,86.7,45.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducacion);
export default __webpack_public_path__ + "static/media/educacion.51a35f6d9c35110ba2812344a4214660.svg";
export { ForwardRef as ReactComponent };